module.exports = __webpack_public_path__ + "static/media/cctv.93039252.jpg";